import { type ComponentPropsWithoutRef, memo } from "react";

import { Badge } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CellDefaultTooltip, CompanyNameCell } from "app/pages/sales-intelligence/common-components/table-cells";
import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search/types";

import SidebarButton from "./SidebarButton";
import { StyledBaseCell, StyledContent } from "./styles";

type Props = ComponentPropsWithoutRef<typeof CompanyNameCell> & {
    leadsType: LeadsType;
    withNewBadge: boolean;
    onToggleRightSidebar: () => void;
    isSidebarDisabled: boolean;
    onClick?: () => void;
    isSidebarABTest: boolean;
};

// TODO update when LeadCell/DomainCell is published
const LeadCell = memo(function LeadCell({
    leadsType,
    withNewBadge,
    onToggleRightSidebar,
    isSidebarDisabled,
    isSidebarABTest,
    ...companyNameCellProps
}: Props) {
    return (
        <StyledBaseCell>
            <StyledContent $withBadges={withNewBadge}>
                <CompanyNameCell
                    {...companyNameCellProps}
                    isSidebarABTest={isSidebarABTest}
                    width="calc(100% - 44px)"
                />
                {!isSidebarABTest ? (
                    <SidebarButton
                        tooltipContent={translate("si.table.cell.LeadCell.tooltip.sidebar.text")}
                        onClick={onToggleRightSidebar}
                        isDisabled={isSidebarDisabled}
                    />
                ) : null}
            </StyledContent>

            {withNewBadge ? (
                <CellDefaultTooltip content={translate(`si.table.cell.LeadCell.${leadsType}.tooltip.new.text`)}>
                    <Badge type="new" />
                </CellDefaultTooltip>
            ) : null}
        </StyledBaseCell>
    );
});

export default LeadCell;
